import React, { useState } from 'react';
import '../../css/modals/SimpleModal.css';
import { IoClose } from 'react-icons/io5';

function SimpleModal({ close, handlerClose, handleCloseModal, modal }) {
	// console.log(modal.title);

	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content-simple ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						handlerClose();
					}}
				>
					<IoClose />
				</button>

				<div className='container-info' style={{ marginBottom: '12px' }}>
					<div className='container-title'>
						<h2>¿Deseas financiar tu máster?</h2>
					</div>

					<p>Habla con nosotros para mayor información</p>

					<a
						href={
							'https://api.whatsapp.com/send?phone=573105868543&text=%F0%9F%94%A5Hola%20Libel%F0%9F%91%8D%2C%20deseo%20informaci%C3%B3n%20de%20los%20entrenamientos%E2%9C%8B'
						}
						// target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Escríbenos
					</a>
				</div>
			</div>
		</div>
	);
}

export default SimpleModal;
